export * from 'af-actions/general/general.actions';
import type { GeneralAction as GeneralActionImport } from 'af-actions/general/general.actionCreators';

export type GeneralAction = GeneralActionImport;
